<template>
  <div class="agf-wizard">
    <header class="wizard-header">
      <div class="wizard-logo-wrapper">
        <img
          class="wizard-logo"
          src="https://flussi.askmanagement.it/logo_agf.png"
          alt="AGF Energy"
        />
  </div>
      <div v-if="inviteChecked && !showFinalThanks && !showCriticalError" class="wizard-steps">
        <div
          v-for="step in steps"
          :key="step.id"
          class="wizard-step"
        >
          <div
            class="wizard-step-circle"
            :class="{
              'wizard-step-circle--active': currentStep === step.id,
              'wizard-step-circle--done': currentStep > step.id
            }"
          >
            <span v-if="currentStep <= step.id">{{ step.id }}</span>
            <span v-else>✓</span>
          </div>
          <span class="wizard-step-label">{{ step.label }}</span>
          <div
            v-if="step.id < steps.length"
            class="wizard-step-line"
            :class="{ 'wizard-step-line--active': currentStep > step.id }"
          />
        </div>
      </div>
    </header>

    <main class="wizard-main">
      <section v-if="showCriticalError" class="wizard-thanks">
        <div class="wizard-thanks-card wizard-thanks-card--error">
          <div class="wizard-error-icon" aria-hidden="true">!</div>
          <h1 class="wizard-title wizard-title--error">{{ criticalErrorTitle }}</h1>
          <p v-if="isInviteExpiredError" class="wizard-error-help">
            Il link di invito non e' piu' valido.
          </p>
          <button type="button" class="wizard-secondary-button wizard-error-action" @click="reloadPage">
            Ricarica pagina
          </button>
        </div>
      </section>

      <section v-else-if="showFinalThanks" class="wizard-thanks">
        <div class="wizard-thanks-card">
          <h1 class="wizard-title">Grazie!</h1>
          <p class="wizard-thanks-text">
            Abbiamo ricevuto la sua richiesta. Riceverà a breve una email di riscontro.
          </p>
          <p v-if="form.email" class="wizard-thanks-email">
            All’indirizzo: <strong>{{ form.email }}</strong>
          </p> 
        </div>
      </section>

      <section v-else-if="!inviteChecked" class="wizard-thanks">
        <div class="wizard-thanks-card">
          <p class="wizard-thanks-text">Caricamento...</p>
        </div>
      </section>

      <section v-else-if="currentStep === 1" class="wizard-card wizard-card--wide wizard-card--xwide">
        <!-- <h1 class="wizard-title">Seleziona l'offerta più adatta a te</h1> -->

        <div class="wizard-info-box" role="note">
          <p class="wizard-info-box-title">Cosa ti serve per procedere</p>
          <p class="wizard-info-box-text">
            Per inserire il contratto ti bastano solo:
          </p>
          <ul class="wizard-info-box-list">
            <li>il tuo <strong>documento d'identità</strong></li>
            <li>l'<strong>ultima fattura</strong> di ogni punto di prelievo</li>
          </ul>
        </div>

        <div class="wizard-toggle-center">
          <div class="wizard-toggle-group wizard-toggle-group--offers">
            <button
              type="button"
              class="wizard-toggle"
              :class="{ 'wizard-toggle--active': selectedCommodity === 'lucegas' }"
              @click="selectedCommodity = 'lucegas'"
            >
              Luce + Gas
            </button>
            <button
              type="button"
              class="wizard-toggle"
              :class="{ 'wizard-toggle--active': selectedCommodity === 'luce' }"
              @click="selectedCommodity = 'luce'"
            >
              Luce
            </button>
            <button
              type="button"
              class="wizard-toggle"
              :class="{ 'wizard-toggle--active': selectedCommodity === 'gas' }"
              @click="selectedCommodity = 'gas'"
            >
              Gas
            </button>
          </div>
        </div>
        <div class="wizard-offer-cards">
          <div
            v-if="offertaLuce && selectedCommodity === 'luce'"
            class="offer-card"
            :class="{ 'offer-card--selected': selectedCommodity === 'luce' }"
          >
            <div class="offer-card-badge-row">
              <p class="offer-card-type offer-card-type--top">{{ getTipoOffertaLabel(offertaLuce) }}</p>
              <div class="offer-card-badge">LUCE</div>
            </div>
            <h3 class="offer-card-title">{{ offertaLuce.name_offerta }}</h3>
            <p class="offer-card-price">
              PUN + {{ offertaLuce.f1.toFixed(3).replace('.', ',') }}€/kWh
            </p>
            <p class="offer-card-pcv">
              {{ offertaLuce.pcv }}€/Mese
            </p>
            <button class="offer-card-cta" type="button" @click="selectTariff('luce')">
              SOTTOSCRIVI LUCE
            </button>
          </div>

          <div
            v-if="offertaGas && selectedCommodity === 'gas'"
            class="offer-card"
            :class="{ 'offer-card--selected': selectedCommodity === 'gas' }"
          >
            <div class="offer-card-badge-row">
              <p class="offer-card-type offer-card-type--top">{{ getTipoOffertaLabel(offertaGas) }}</p>
              <div class="offer-card-badge">GAS</div>
            </div>
            <h3 class="offer-card-title">{{ offertaGas.name_offerta }}</h3>
            <p class="offer-card-price">
              PSV + {{ offertaGas.m.toFixed(3).replace('.', ',') }}€/Smc
            </p>
            <p class="offer-card-pcv">
              {{ offertaGas.pcv }}€/Mese
            </p>
            <button class="offer-card-cta" type="button" @click="selectTariff('gas')">
              SOTTOSCRIVI GAS
            </button>
          </div>

         
          <div
            v-if="offertaLuce && offertaGas && selectedCommodity === 'lucegas'"
            class="offer-card offer-card--combined"
            :class="{ 'offer-card--selected': selectedCommodity === 'lucegas' }"
          >
            <div class="offer-card-badge">LUCE & GAS</div>
            <h3 class="offer-card-title">{{ offertaLuce.name_offerta }}</h3>
            <div class="offer-card-combined-row">
              <div class="offer-card-side">
                <span class="offer-card-tag">LUCE</span>
                <p class="offer-card-type offer-card-type--small ml-4">{{ getTipoOffertaLabel(offertaLuce) }}</p>
                <p class="offer-card-price-small">
                  PUN + {{ offertaLuce.f1.toFixed(3).replace('.', ',') }}€/kWh
                </p>
                <p class="offer-card-pcv">
                  {{ offertaLuce.pcv }}€/Mese
                </p>
              </div>
              <div class="offer-card-side">
                <span class="offer-card-tag">GAS</span>
                <p class="offer-card-type offer-card-type--small ml-4">{{ getTipoOffertaLabel(offertaGas) }}</p>
                <p class="offer-card-price-small">
                  PSV + {{ offertaGas.m.toFixed(3).replace('.', ',') }}€/Smc
                </p>
                <p class="offer-card-pcv">
                  {{ offertaGas.pcv }}€/Mese
                </p>
              </div>
            </div>
            <button class="offer-card-cta" type="button" @click="selectTariff('lucegas')">
              SOTTOSCRIVI LUCE & GAS
            </button>
          </div>
        </div>
      </section>

      
      <section v-else-if="currentStep === 2" class="wizard-card wizard-card--narrow">
        <h1 class="wizard-title">Le tue informazioni</h1>

        <form class="wizard-form" @submit.prevent="goNext">
          <div class="wizard-field-grid">
            <div class="wizard-field">
              <label>Nome</label>
              <input type="text" v-model="form.nome" placeholder="Nome" />
              <p v-if="step2Errors.nome" class="wizard-field-error">
                {{ step2Errors.nome }}
              </p>
            </div>
            <div class="wizard-field">
              <label>Cognome</label>
              <input type="text" v-model="form.cognome" placeholder="Cognome" />
              <p v-if="step2Errors.cognome" class="wizard-field-error">
                {{ step2Errors.cognome }}
              </p>
            </div> 
          </div>
          <div class="wizard-field-grid">
            <div class="wizard-field">
              <label>Email</label>
              <input type="email" v-model="form.email" placeholder="Email" />
              <p v-if="step2Errors.email" class="wizard-field-error">
                {{ step2Errors.email }}
              </p>
            </div>
            <div class="wizard-field">
              <label>Numero di cellulare</label>
              <input type="tel" v-model="form.telefono" placeholder="Numero di cellulare" />
              <p v-if="step2Errors.telefono" class="wizard-field-error">
                {{ step2Errors.telefono }}
              </p>
            </div>
          </div>

          <div class="wizard-field">
            <label>Codice fiscale</label>
            <input
              type="text"
              v-model="form.codiceFiscale"
              placeholder="Codice fiscale"
              @input="form.codiceFiscale = (form.codiceFiscale || '').toUpperCase()"
            />
            <p v-if="step2Errors.codiceFiscale" class="wizard-field-error">
              {{ step2Errors.codiceFiscale }}
            </p>
          </div>

          <div class="wizard-field">
            <label>Documento d'identità *</label>
            <input
              type="file"
              accept=".pdf,.png,.jpg,.jpeg,.webp"
              required
              @change="onDocumentoIdentitaChange"
            />
            <p class="wizard-field-hint">Campo obbligatorio</p>
            <p v-if="form.documentoIdentitaNome" class="wizard-file-name">
              File selezionato: {{ form.documentoIdentitaNome }}
            </p>
            <p v-if="step2Errors.documentoIdentita" class="wizard-field-error">
              {{ step2Errors.documentoIdentita }}
            </p>
          </div>

          <div class="wizard-subsection">
            <h2 class="wizard-subtitle">Indirizzo di residenza</h2>

            <div class="wizard-field-grid wizard-field-grid--residenza">
              <div class="wizard-field">
                <label>Toponimo</label>
                <select v-model="form.residenzaToponimo">
                  <option value="" disabled hidden>Seleziona toponimo</option>
                  <option v-for="t in toponimoOptions" :key="`res-${t}`" :value="t">{{ t }}</option>
                </select>
                <p v-if="step2Errors.residenzaToponimo" class="wizard-field-error">
                  {{ step2Errors.residenzaToponimo }}
                </p>
              </div>
              <div class="wizard-field">
                <label>Indirizzo</label>
                <input type="text" v-model="form.residenzaVia" placeholder="Indirizzo di residenza" />
                <p v-if="step2Errors.residenzaVia" class="wizard-field-error">
                  {{ step2Errors.residenzaVia }}
                </p>
              </div>
              <div class="wizard-field">
                <label>N. Civico</label>
                <input type="text" v-model="form.residenzaCivico" placeholder="N. Civico" />
                <p v-if="step2Errors.residenzaCivico" class="wizard-field-error">
                  {{ step2Errors.residenzaCivico }}
                </p>
              </div>
              <div class="wizard-field">
                <label>CAP</label>
                <input type="text" v-model="form.residenzaCap" placeholder="CAP" />
                <p v-if="step2Errors.residenzaCap" class="wizard-field-error">
                  {{ step2Errors.residenzaCap }}
                </p>
              </div>
              <div class="wizard-field">
                <label>Provincia</label>
                <div class="wizard-search-dropdown">
                  <div class="wizard-dropdown-input-wrap">
                    <input
                      type="text"
                      v-model="residenzaProvinceSearch"
                      placeholder="Provincia"
                      @focus="openResidenzaProvinceDropdown"
                      @input="onResidenzaProvinceSearchInput"
                      @blur="closeResidenzaProvinceDropdown"
                    />
                    <span class="wizard-dropdown-caret" aria-hidden="true" />
                  </div>
                  <div v-if="residenzaProvinceDropdownOpen" class="wizard-search-dropdown-list">
                    <div v-if="isLoadingProvinces" class="wizard-search-dropdown-empty">
                      Caricamento...
                    </div>
                    <div v-else-if="filteredResidenzaProvinceOptions.length === 0" class="wizard-search-dropdown-empty">
                      Nessun risultato
                    </div>
                    <button
                      v-for="p in filteredResidenzaProvinceOptions"
                      :key="`res-prov-${getProvinceKey(p)}`"
                      type="button"
                      class="wizard-search-dropdown-item"
                      @mousedown.prevent="selectResidenzaProvince(p)"
                    >
                      {{ getProvinceLabel(p) }}
                    </button>
                  </div>
                </div>
                <p v-if="step2Errors.residenzaProvincia" class="wizard-field-error">
                  {{ step2Errors.residenzaProvincia }}
                </p>
              </div>
              <div class="wizard-field">
                <label>Comune</label>
                <div class="wizard-search-dropdown">
                  <div class="wizard-dropdown-input-wrap">
                    <input
                      type="text"
                      v-model="residenzaCitySearch"
                      placeholder="Comune"
                      :disabled="!form.residenzaProvincia"
                      @focus="openResidenzaCityDropdown"
                      @input="onResidenzaCitySearchInput"
                      @blur="closeResidenzaCityDropdown"
                    />
                    <span class="wizard-dropdown-caret" aria-hidden="true" />
                  </div>
                  <div v-if="residenzaCityDropdownOpen" class="wizard-search-dropdown-list">
                    <div v-if="isLoadingCities" class="wizard-search-dropdown-empty">
                      Caricamento...
                    </div>
                    <div v-else-if="filteredResidenzaCityOptions.length === 0" class="wizard-search-dropdown-empty">
                      Nessun risultato
                    </div>
                    <button
                      v-for="c in filteredResidenzaCityOptions"
                      :key="`res-city-${getCityKey(c)}`"
                      type="button"
                      class="wizard-search-dropdown-item"
                      @mousedown.prevent="selectResidenzaCity(c)"
                    >
                      {{ getCityName(c) }}
                    </button>
                  </div>
                </div>
                <p v-if="step2Errors.residenzaCitta" class="wizard-field-error">
                  {{ step2Errors.residenzaCitta }}
                </p>
              </div>
            </div>
          </div>

          <div class="wizard-subsection">
            <p class="wizard-text mt-3">
              Se desideri saperne di più su come utilizziamo i tuoi dati personali puoi consultare
              l’informativa sulla <a href="https://agfenergy.it/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy</a>.
            </p>
          </div>
        </form>
      </section>

      <section v-else-if="currentStep === 3" class="wizard-card wizard-card--wide">
        <h1 class="wizard-title">Inserisci i dettagli del punto di fornitura</h1>

        <div v-if="showResidenzaDialog" class="wizard-dialog-backdrop">
          <div class="wizard-dialog">
            <h2 class="wizard-summary-title">Conferma indirizzo</h2>
            <p class="wizard-text">
              L'indirizzo di residenza coincide con l'indirizzo di fornitura?
            </p>
            <div class="wizard-dialog-actions">
              <button type="button" class="wizard-dialog-btn wizard-dialog-btn--yes" @click="onResidenzaDialogChoice(true)">
                Si
              </button>
              <button type="button" class="wizard-dialog-btn wizard-dialog-btn--no" @click="onResidenzaDialogChoice(false)">
                No
              </button>
            </div>
          </div>
        </div>

        <form class="wizard-form" @submit.prevent="goNext">
          <div class="wizard-field">
            <div class="wizard-field-header">
              <label>Il tuo indirizzo di fornitura</label>
            </div>

            <div class="wizard-address-grid">
              <div class="wizard-field-inline">
                <select v-model="form.indirizzoToponimo">
                  <option value="" disabled hidden>Seleziona toponimo</option>
                  <option v-for="t in toponimoOptions" :key="t" :value="t">{{ t }}</option>
                </select>
                <p v-if="step3Errors.indirizzoToponimo" class="wizard-field-error">
                  {{ step3Errors.indirizzoToponimo }}
                </p>
              </div>

              <div class="wizard-field-inline wizard-field-inline--address">
                <input
                  type="text"
                  v-model="form.indirizzoVia"
                  placeholder="Indirizzo"
                />
                <p v-if="step3Errors.indirizzoVia" class="wizard-field-error">
                  {{ step3Errors.indirizzoVia }}
                </p>
              </div>

              <div class="wizard-field-inline">
                <input
                  type="text"
                  v-model="form.indirizzoCivico"
                  placeholder="N. Civico"
                />
                <p v-if="step3Errors.indirizzoCivico" class="wizard-field-error">
                  {{ step3Errors.indirizzoCivico }}
                </p>
              </div>

              <div class="wizard-field-inline">
                <input
                  type="text"
                  v-model="form.indirizzoCap"
                  placeholder="CAP"
                />
                <p v-if="step3Errors.indirizzoCap" class="wizard-field-error">
                  {{ step3Errors.indirizzoCap }}
                </p>
              </div>

              <div class="wizard-field-inline">
                <div class="wizard-search-dropdown">
                  <div class="wizard-dropdown-input-wrap">
                    <input
                      type="text"
                      v-model="provinceSearch"
                      placeholder="Provincia"
                      @focus="openProvinceDropdown"
                      @input="onProvinceSearchInput"
                      @blur="closeProvinceDropdown"
                    />
                    <span class="wizard-dropdown-caret" aria-hidden="true" />
                  </div>

                  <div v-if="provinceDropdownOpen" class="wizard-search-dropdown-list">
                    <div v-if="isLoadingProvinces" class="wizard-search-dropdown-empty">
                      Caricamento...
                    </div>
                    <div v-else-if="filteredProvinceOptions.length === 0" class="wizard-search-dropdown-empty">
                      Nessun risultato
                    </div>
                    <button
                      v-for="p in filteredProvinceOptions"
                      :key="getProvinceKey(p)"
                      type="button"
                      class="wizard-search-dropdown-item"
                      @mousedown.prevent="selectProvince(p)"
                    >
                      {{ getProvinceLabel(p) }}
                    </button>
                  </div>
                </div>

                <p v-if="step3Errors.indirizzoProvincia" class="wizard-field-error">
                  {{ step3Errors.indirizzoProvincia }}
                </p>
              </div>

              <div class="wizard-field-inline">
                <div class="wizard-search-dropdown">
                  <div class="wizard-dropdown-input-wrap">
                    <input
                      type="text"
                      v-model="citySearch"
                      placeholder="Comune"
                      :disabled="!form.indirizzoProvincia"
                      @focus="openCityDropdown"
                      @input="onCitySearchInput"
                      @blur="closeCityDropdown"
                    />
                    <span class="wizard-dropdown-caret" aria-hidden="true" />
                  </div>

                  <div v-if="cityDropdownOpen" class="wizard-search-dropdown-list">
                    <div v-if="isLoadingCities" class="wizard-search-dropdown-empty">
                      Caricamento...
                    </div>
                    <div v-else-if="filteredCityOptions.length === 0" class="wizard-search-dropdown-empty">
                      Nessun risultato
                    </div>
                    <button
                      v-for="c in filteredCityOptions"
                      :key="getCityKey(c)"
                      type="button"
                      class="wizard-search-dropdown-item"
                      @mousedown.prevent="selectCity(c)"
                    >
                      {{ getCityName(c) }}
                    </button>
                  </div>
                </div>

                <p v-if="step3Errors.indirizzoCitta" class="wizard-field-error">
                  {{ step3Errors.indirizzoCitta }}
                </p>
              </div>
            </div>
          </div>

          <div class="wizard-subsection">
            <h2 class="wizard-subtitle">Dati di fornitura</h2>
            <div v-if="selectedCommodity === 'luce' || selectedCommodity === 'lucegas'">
              <div class="wizard-field">
                <label>POD (luce)</label>
                <input type="text" v-model="form.pod" placeholder="POD (luce)" />
                <p v-if="step3Errors.pod" class="wizard-field-error">
                  {{ step3Errors.pod }}
                </p>
              </div>

              <div class="wizard-accordion" @click="togglePodInfo">
                <div class="wizard-accordion-header">
                  <span class="wizard-accordion-icon">⚡</span>
                  <span class="wizard-accordion-title">Dove posso trovare il codice POD?</span>
                  <span class="wizard-accordion-arrow">
                    {{ showPodInfo ? '▲' : '▼' }}
                  </span>
                </div>
                <transition name="wizard-accordion-fade">
                  <div v-if="showPodInfo" class="wizard-accordion-body">
                    <p>
                      Lo trovi all’interno della bolletta della luce. Inizia con <strong>“IT”</strong> ed è composto
                      da <strong>14 o 15 caratteri</strong>.
                    </p>
                  </div>
                </transition>
              </div>

              <div class="wizard-field">
                <label>La fornitura luce è attualmente intestata a te?</label>
                <div class="wizard-radio-group">
                  <label>
                    <input type="radio" value="si" v-model="form.intestatarioLuce" />
                    Sì, la fornitura è intestata a me
                  </label>
                  <label>
                    <input type="radio" value="no" v-model="form.intestatarioLuce" />
                    No, è intestata ad un'altra persona
                  </label>
                </div>
              </div>

              <div v-if="form.intestatarioLuce === 'no'" class="wizard-inline-card">
                <p class="wizard-inline-note">
                  Ok, procederemo a effettuare una voltura.
                </p>

                <div class="wizard-field">
                  <label>Inserisci il codice fiscale dell’attuale intestatario della fornitura luce</label>
                  <input
                    type="text"
                    v-model="form.codiceFiscaleIntestatarioLuce"
                    placeholder="Codice fiscale"
                  />
                  <p v-if="step3Errors.codiceFiscaleIntestatarioLuce" class="wizard-field-error">
                    {{ step3Errors.codiceFiscaleIntestatarioLuce }}
                  </p>
                </div>

                <div class="wizard-field">
                  <label>Comunicaci l’autolettura del contatore della luce</label>
                  <p class="wizard-text wizard-text--compact">
                    Ci sarà utile per emettere una bolletta in linea con i tuoi consumi effettivi. Se non ce l'hai a
                    portata di mano, puoi saltare questo passaggio.
                  </p>
                  <input
                    type="number"
                    inputmode="numeric"
                    v-model="form.autoletturaLuce"
                    placeholder="Autolettura (opzionale)"
                  />
                </div>
              </div>
            </div>
            <div v-if="selectedCommodity === 'gas' || selectedCommodity === 'lucegas'" class="wizard-subsection-inner">
              <div class="wizard-field">
                <label>PDR (gas)</label>
                <input type="text" v-model="form.pdr" placeholder="PDR (gas)" />
                <p v-if="step3Errors.pdr" class="wizard-field-error">
                  {{ step3Errors.pdr }}
                </p>
              </div>

              <div class="wizard-accordion" @click="togglePdrInfo">
                <div class="wizard-accordion-header">
                  <span class="wizard-accordion-icon">🔥</span>
                  <span class="wizard-accordion-title">Dove posso trovare il codice PDR?</span>
                  <span class="wizard-accordion-arrow">
                    {{ showPdrInfo ? '▲' : '▼' }}
                  </span>
                </div>
                <transition name="wizard-accordion-fade">
                  <div v-if="showPdrInfo" class="wizard-accordion-body">
                    <p>
                      Lo trovi all’interno della bolletta del gas ed è composto da
                      <strong>14 numeri</strong>.
                    </p>
                  </div>
                </transition>
              </div>

              <div class="wizard-field">
                <label>La fornitura gas è attualmente intestata a te?</label>
                <div class="wizard-radio-group">
                  <label>
                    <input type="radio" value="si" v-model="form.intestatarioGas" />
                    Sì, la fornitura è intestata a me
                  </label>
                  <label>
                    <input type="radio" value="no" v-model="form.intestatarioGas" />
                    No, è intestata ad un'altra persona
                  </label>
                </div>
              </div>

              <div v-if="form.intestatarioGas === 'no'" class="wizard-inline-card">
                <p class="wizard-inline-note">
                  Ok, procederemo a effettuare una voltura.
                </p>

                <div class="wizard-field">
                  <label>Inserisci il codice fiscale dell’attuale intestatario della fornitura gas</label>
                  <input
                    type="text"
                    v-model="form.codiceFiscaleIntestatarioGas"
                    placeholder="Codice fiscale"
                  />
                  <p v-if="step3Errors.codiceFiscaleIntestatarioGas" class="wizard-field-error">
                    {{ step3Errors.codiceFiscaleIntestatarioGas }}
                  </p>
                </div>

                <div class="wizard-field">
                  <label>Comunicaci l’autolettura del contatore del gas</label>
                  <p class="wizard-text wizard-text--compact">
                    Ci sarà utile per emettere una bolletta in linea con i tuoi consumi effettivi. Se non ce l'hai a
                    portata di mano, puoi saltare questo passaggio.
                  </p>
                  <input
                    type="number"
                    inputmode="numeric"
                    v-model="form.autoletturaGas"
                    placeholder="Autolettura (opzionale)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="wizard-field">
            <label>Ultima bolletta *</label>
            <input
              type="file"
              accept=".pdf,.png,.jpg,.jpeg,.webp"
              required
              @change="onUltimaBollettaChange"
            />
            <p class="wizard-field-hint">Campo obbligatorio</p>
            <p v-if="form.ultimaBollettaNome" class="wizard-file-name">
              File selezionato: {{ form.ultimaBollettaNome }}
            </p>
            <p v-if="step3Errors.ultimaBolletta" class="wizard-field-error">
              {{ step3Errors.ultimaBolletta }}
            </p>
          </div>

          <div class="wizard-field">
            <label>Dati di fornitura *</label>
            <div class="wizard-radio-group wizard-radio-group--inline">
              <label>
                <input type="radio" value="1" v-model="form.fornituraTipo" />
                Domestico Residente
              </label>
              <label>
                <input type="radio" value="2" v-model="form.fornituraTipo" />
                Domestico non Residente
              </label>
              <label>
                <input type="radio" value="3" v-model="form.fornituraTipo" />
                Altri Usi
              </label>
            </div>
            <p v-if="step3Errors.fornituraTipo" class="wizard-field-error">
              {{ step3Errors.fornituraTipo }}
            </p>
          </div>
        </form>
      </section>

      <section v-else-if="currentStep === 4" class="wizard-card wizard-card--wide">
        <h1 class="wizard-title">Metodo di pagamento</h1>

        <div class="wizard-offer-summary">
          <div class="wizard-offer-name">Dettagli sulla tariffa</div>
          <ul class="wizard-offer-list" v-if="selectedCommodity !== 'lucegas'">
            <li><strong>Offerta:</strong> {{ offertaSelezionataNome }}</li>
            <li><strong>Tipologia:</strong> {{ selectedCommodity === 'luce' ? 'Luce' : 'Gas' }}</li>
            <li><strong>Prezzo energia:</strong> {{ offertaSelezionataPrezzo }}</li>
            <li><strong>PCV:</strong> {{ offertaSelezionataPcv }}</li>
          </ul>
          <ul class="wizard-offer-list" v-else>
            <li><strong>Offerta:</strong> {{ offertaCombinataNome }}</li>
            <li><strong>Tipologia:</strong> Luce + Gas</li>
            <li><strong>Prezzo luce:</strong> {{ prezzoLuce }}</li>
            <li><strong>Prezzo gas:</strong> {{ prezzoGas }}</li>
            <li><strong>PCV luce/gas:</strong> {{ pcvLuceGas }}</li>
          </ul>
        </div>

        <form class="wizard-form" @submit.prevent="goNext">
          <div class="wizard-field">
            <label>Metodo di pagamento</label>
            <p class="wizard-text wizard-text--compact">
              Il pagamento avverrà tramite <strong>addebito diretto su conto corrente (SEPA)</strong>.
              Inserisci i dati del tuo conto.
            </p>
          </div>

          <div class="wizard-field-grid">
            <div class="wizard-field">
              <label>Nome completo dell'intestatario del conto</label>
              <input
                type="text"
                v-model="form.intestatarioConto"
                placeholder="Nome completo dell'intestatario del conto"
              />
              <p v-if="step4Errors.intestatarioConto" class="wizard-field-error">
                {{ step4Errors.intestatarioConto }}
              </p>
            </div>
            <div class="wizard-field">
              <label>IBAN del conto</label>
              <input
                type="text"
                v-model="form.iban"
                placeholder="IBAN del conto"
              />
              <p v-if="step4Errors.iban" class="wizard-field-error">
                {{ step4Errors.iban }}
              </p>
            </div>
          </div>
        </form>
      </section>

      <section v-else-if="currentStep === 5" class="wizard-card wizard-card--wide wizard-card--xwide">
        <h1 class="wizard-title">Riepilogo della tua richiesta</h1>

        <div class="wizard-summary-grid">
          <div class="wizard-summary-box">
            <h2 class="wizard-summary-title">I tuoi dati personali</h2>
            <p><strong>Nome e cognome:</strong> {{ form.nome }} {{ form.cognome }}</p>
            <p><strong>Email:</strong> {{ form.email }}</p>
            <p><strong>Numero:</strong> {{ form.telefono }}</p>
            <p><strong>Codice fiscale:</strong> {{ form.codiceFiscale }}</p>
          </div>

          <div class="wizard-summary-box">
            <h2 class="wizard-summary-title">I tuoi indirizzi</h2>
            <p><strong>Indirizzo di residenza:</strong> {{ indirizzoResidenzaCompleto || indirizzoFornituraCompleto }}</p>
            <p><strong>Indirizzo di fornitura:</strong> {{ indirizzoFornituraCompleto }}</p>
            <p><strong>POD:</strong> {{ form.pod }}</p>
          </div>

          <div class="wizard-summary-box">
            <h2 class="wizard-summary-title">La tua tariffa</h2>
            <template v-if="selectedCommodity !== 'lucegas'">
              <p><strong>{{ offertaSelezionataNome }}</strong></p>
              <p>{{ selectedCommodity === 'luce' ? 'Luce' : 'Gas' }} - {{ offertaSelezionataPrezzo }}</p>
              <p>PCV: {{ offertaSelezionataPcv }}</p>
            </template>
            <template v-else>
              <p><strong>{{ offertaCombinataNome }}</strong></p>
              <p>Luce - {{ prezzoLuce }}</p>
              <p>Gas - {{ prezzoGas }}</p>
              <p>PCV luce/gas: {{ pcvLuceGas }}</p>
            </template>
          </div>

          <div class="wizard-summary-box">
            <h2 class="wizard-summary-title">Pagamento</h2>
            <p>
              <strong>Metodo:</strong> Addebito su conto corrente (SEPA)
            </p>
            <p>
              <strong>Intestatario conto:</strong> {{ form.intestatarioConto }}<br />
              <strong>IBAN:</strong> {{ form.iban }}
            </p>
          </div>
        </div>

        <div class="wizard-conditions">
          <h2 class="wizard-summary-title">Condizioni generali di fornitura</h2>
          <p class="wizard-text">
            Io sottoscritto dichiaro espressamente di aver ricevuto l’informativa e di autorizzare
            il titolare del trattamento all’utilizzo dei miei dati per le finalità di seguito indicate:
          </p>

          <div class="wizard-consent-grid">
            <div class="wizard-consent-col">
              <p class="wizard-consent-label">Grado di soddisfazione della clientela:</p>
              <label><input type="radio" value="si" v-model="form.consensoClienteSoddisfazione" /> SI</label>
              <label><input type="radio" value="no" v-model="form.consensoClienteSoddisfazione" /> NO</label>
              <p v-if="showStep5Errors && !form.consensoClienteSoddisfazione" class="wizard-field-error">
                Seleziona una risposta.
              </p>
            </div>

            <div class="wizard-consent-col">
              <p class="wizard-consent-label">Attività promozionali:</p>
              <label><input type="radio" value="si" v-model="form.consensoClientePromo" /> SI</label>
              <label><input type="radio" value="no" v-model="form.consensoClientePromo" /> NO</label>
              <p v-if="showStep5Errors && !form.consensoClientePromo" class="wizard-field-error">
                Seleziona una risposta.
              </p>
            </div>

            <div class="wizard-consent-col">
              <p class="wizard-consent-label">Attività di Marketing:</p>
              <label><input type="radio" value="si" v-model="form.consensoClienteMarketing" /> SI</label>
              <label><input type="radio" value="no" v-model="form.consensoClienteMarketing" /> NO</label>
              <p v-if="showStep5Errors && !form.consensoClienteMarketing" class="wizard-field-error">
                Seleziona una risposta.
              </p>
            </div>
          </div>

          <p class="wizard-text">
            Autorizzo altresì il trattamento dei miei dati da parte dei soggetti terzi per finalità
            di seguito elencate:
          </p>

          <div class="wizard-consent-grid">
            <div class="wizard-consent-col">
              <p class="wizard-consent-label">Grado di soddisfazione della clientela:</p>
              <label><input type="radio" value="si" v-model="form.consensoTerziSoddisfazione" /> SI</label>
              <label><input type="radio" value="no" v-model="form.consensoTerziSoddisfazione" /> NO</label>
              <p v-if="showStep5Errors && !form.consensoTerziSoddisfazione" class="wizard-field-error">
                Seleziona una risposta.
              </p>
            </div>

            <div class="wizard-consent-col">
              <p class="wizard-consent-label">Attività promozionali:</p>
              <label><input type="radio" value="si" v-model="form.consensoTerziPromo" /> SI</label>
              <label><input type="radio" value="no" v-model="form.consensoTerziPromo" /> NO</label>
              <p v-if="showStep5Errors && !form.consensoTerziPromo" class="wizard-field-error">
                Seleziona una risposta.
              </p>
            </div>

            <div class="wizard-consent-col">
              <p class="wizard-consent-label">Attività di Marketing:</p>
              <label><input type="radio" value="si" v-model="form.consensoTerziMarketing" /> SI</label>
              <label><input type="radio" value="no" v-model="form.consensoTerziMarketing" /> NO</label>
              <p v-if="showStep5Errors && !form.consensoTerziMarketing" class="wizard-field-error">
                Seleziona una risposta.
              </p>
            </div>
          </div>

          <div
            class="wizard-checkbox"
            :class="{ 'wizard-checkbox--error': showStep5Errors && !form.accettaEsecuzione }"
          >
            <p class="wizard-consent-label">Esecuzione *</p>
            <label>
              <input type="checkbox" v-model="form.accettaEsecuzione" />
              Con la firma della presente proposta contrattuale richiedo l'esecuzione anticipata del contratto e, pertanto, le operazioni per l’attivazione della fornitura potranno essere avviate da AGF ENERGY SpA prima che sia decorso il termine per l’esercizio del diritto di ripensamento (14 giorni dalla conclusione del Contratto)
            </label>
            <p v-if="showStep5Errors && !form.accettaEsecuzione" class="wizard-field-error">
              Per continuare devi accettare questa condizione.
            </p>
          </div>

          <p class="wizard-legal-paragraph">
            Il cliente con sottoscrizione del presente modulo, formula la proposta di contratto a AGF ENERGY contestualmente dichiara di aver ricevuto e preso visione (e di accettare i contenuti) dei seguenti allegati: Condizioni Tecnico Economiche, Livelli di qualità commerciale, Condizioni Generali di Fornitura (comprensive di Informativa sul trattamento dei dati personali), Modello di comunicazione dati catastali, Scheda sintetica e Scheda di confrontabilità dell’offerta (quest’ultima per i soli clienti domestici). Il cliente dichiara: Di recedere irrevocabilmente dai contratti di fornitura di gas e/o energia elettrica in essere con i fornitori ivi indicati, incaricando AGF ENERGY darne comunicazione a quest’ultimi e che, a partire dalla data di efficacia del predetto recesso sarà rifornito da AGF ENERGY Di dare specifico mandato con rappresentanza ad AGF ENERGY affinché formalizzi ai fornitori uscenti di gas e/o energia elettrica i suddetti recessi ed effettui la somministrazione da parte di AGF ENERGY con l’intervenuta efficacia dei recessi esercitati eventualmente presso i precedenti fornitori, nel rispetto dei tempi previsti dalla normativa vigente Del. AEEG n°144/07 e s.m.i Ai sensi e per gli effetti degli artt. 1341 e 1342 cod. civ., il Cliente dichiara di approvare specificatamente i seguenti articoli delle Condizioni Generali di Fornitura: 2 - Oggetto del contratto; 3 – Conclusione e consegna del Contratto o della conferma del Contratto, perfezionamento del Contratto; 4 - Durata e decorrenza del Contratto, diritto di recesso e diritto di ripensamento; 6 - Cessione del contratto; 7 - Condizioni di fornitura; 9 – Responsabilità; 13 - Modalità di fatturazione e pagamento; 14 - Ritardo nei pagamenti; 15 – Garanzie; 16 - Cessione dei crediti; 17 - Clausola risolutiva espressa; 18 - Forza maggiore.
          </p>

          <div
            class="wizard-checkbox"
            :class="{ 'wizard-checkbox--error': showStep5Errors && !form.accettaCondizioni }"
          >
            <label>
              <input type="checkbox" v-model="form.accettaCondizioni" />
              Ho letto e accettato le condizioni di fornitura.
            </label>
            <p v-if="showStep5Errors && !form.accettaCondizioni" class="wizard-field-error">
              Per continuare devi accettare questa condizione.
            </p>
          </div>
          <div
            class="wizard-checkbox"
            :class="{ 'wizard-checkbox--error': showStep5Errors && !form.accettaClausole }"
          >
            <label>
              <input type="checkbox" v-model="form.accettaClausole" />
              Ho letto e accettato le Condizioni Tecnico Economiche (CTE).
            </label>
            <p v-if="showStep5Errors && !form.accettaClausole" class="wizard-field-error">
              Per continuare devi accettare questa condizione.
            </p>
          </div>
        </div>

        <div v-if="identityOtpRequested && !identityOtpVerified" class="wizard-otp-panel">
          <h2 class="wizard-summary-title">Conferma Identità</h2>
          <div class="wizard-field">
            <label>Codice di verifica (OTP)</label>
            <input
              type="text"
              v-model="otpCode"
              placeholder="6 cifre"
              inputmode="numeric"
            />
          </div>
          <p v-if="otpError" class="wizard-field-error">{{ otpError }}</p>
          <div class="wizard-otp-actions mt-2">
            <button
              type="button"
              class="wizard-primary-button"
              :disabled="!otpCode || otpCode.toString().length < 6"
              @click="verifyOtp"
            >
              Verifica codice
            </button>
            <button
              type="button"
              class="wizard-secondary-button"
              :disabled="otpResendLoading || otpResendCountdown > 0"
              @click="requestOtp('resend')"
            >
              {{ otpResendButtonLabel }}
            </button>
          </div>
        </div>
      </section>
    </main>

    <footer v-if="currentStep !== 1 && !showFinalThanks && !showCriticalError" class="wizard-footer">
      <button
        v-if="currentStep !== 1"
        type="button"
        class="wizard-link-back"
        @click="goPrev"
      >
         Indietro
      </button>

      <button
        v-if="currentStep > 1 && currentStep < steps.length"
        type="button"
        class="wizard-primary-button"
        @click="goNext"
      >
        Avanti
      </button>
      <button
        v-if="currentStep === steps.length && !identityOtpVerified"
        type="button"
        class="wizard-primary-button"
        :disabled="!canConferma || identityOtpRequested"
        @click="requestOtp"
      >
        Conferma Identità
      </button>
      <button
        v-if="currentStep === steps.length && identityOtpVerified"
        type="button"
        class="wizard-primary-button"
        :disabled="!canConferma || isSubmittingCompletedWizard"
        @click="confirm"
      >
        <span v-if="isSubmittingCompletedWizard" class="wizard-btn-loading">
          <span class="wizard-spinner" aria-hidden="true" />
          Invio in corso...
        </span>
        <span v-else>Entra in AGF</span>
      </button>
    </footer>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted } from 'vue'
import Service from '@/services/ask-pratiche/pratiche-wizard'

export default {
  name: 'LandingPageAgf',
  data () {
    return {
      currentStep: 1,
      steps: [
        { id: 1, label: 'Offerte' },
        { id: 2, label: 'I tuoi dati' },
        { id: 3, label: 'Fornitura' },
        { id: 4, label: 'Pagamento' },
        { id: 5, label: 'Riepilogo' }
      ],
      form: {
        nome: '',
        cognome: '',
        email: '',
        telefono: '',
        codiceFiscale: '',
        documentoIdentita: null,
        documentoIdentitaNome: '',
        residenzaToponimo: '',
        residenzaVia: '',
        residenzaCivico: '',
        residenzaCap: '',
        residenzaCitta: '',
        residenzaCittaId: '',
        residenzaProvincia: '',
        indirizzoToponimo: '',
        indirizzoVia: '',
        indirizzoCivico: '',
        indirizzoCap: '',
        indirizzoCitta: '',
        indirizzoCittaId: '',
        indirizzoProvincia: '',
        residenzaUguale: true,
        indirizzoResidenza: '',
        pod: '',
        pdr: '',
        fornituraTipo: '1',
        ultimaBolletta: null,
        ultimaBollettaNome: '',
        intestatarioLuce: 'si',
        intestatarioGas: 'si',
        codiceFiscaleIntestatarioLuce: '',
        codiceFiscaleIntestatarioGas: '',
        autoletturaLuce: '',
        autoletturaGas: '',
        metodoPagamento: 'RID',
        intestatarioConto: '',
        iban: '',
        consensoClienteSoddisfazione: 'si',
        consensoClientePromo: 'si',
        consensoClienteMarketing: 'si',
        consensoTerziSoddisfazione: 'si',
        consensoTerziPromo: 'si',
        consensoTerziMarketing: 'si',
        accettaEsecuzione: true,
        accettaCondizioni: true,
        accettaClausole: true,
      },
      selectedCommodity: 'lucegas',
      toponimoOptions: ['Via', 'Viale', 'Piazza', 'Corso', 'Largo', 'Strada', 'Contrada', 'Vicolo'],
      offerteAgf: [],
      showPodInfo: false,
      showPdrInfo: false,
      step2Errors: {},
      step2ErrorList: [],
      step3Errors: {},
      step3ErrorList: [],
      step4Errors: {},
      provinceOptions: [],
      provinceSearch: '',
      provinceDropdownOpen: false,
      cityOptions: [],
      citySearch: '',
      cityDropdownOpen: false,
      residenzaProvinceSearch: '',
      residenzaProvinceDropdownOpen: false,
      residenzaCityOptions: [],
      residenzaCitySearch: '',
      residenzaCityDropdownOpen: false,
      showResidenzaDialog: false,
      residenzaDialogHandled: false,
      isLoadingProvinces: false,
      isLoadingCities: false,
      identityOtpRequested: false,
      identityOtpVerified: false,
      otpCode: '',
      otpError: '',
      otpExpiresAt: null,
      otpSessionId: '',
      otpResendLoading: false,
      otpResendCountdown: 0,
      otpResendTimerId: null,
      isSubmittingCompletedWizard: false,
      sessionId: '',
      showStep5Errors: false,
      showFinalThanks: false,
      showCriticalError: false,
      criticalErrorMessage: 'è stato riscontrato un problema, ricaricare la pagina',
      inviteChecked: false
    }
  },
  computed: {
    canConferma () {
      return (
        ['si', 'no'].includes(this.form.consensoClienteSoddisfazione) &&
        ['si', 'no'].includes(this.form.consensoClientePromo) &&
        ['si', 'no'].includes(this.form.consensoClienteMarketing) &&
        ['si', 'no'].includes(this.form.consensoTerziSoddisfazione) &&
        ['si', 'no'].includes(this.form.consensoTerziPromo) &&
        ['si', 'no'].includes(this.form.consensoTerziMarketing) &&
        this.form.accettaEsecuzione &&
        this.form.accettaCondizioni &&
        this.form.accettaClausole
      )
    },
    indirizzoFornituraCompleto () {
      const { indirizzoCivico, indirizzoCap, indirizzoCitta, indirizzoProvincia } = this.form
      const provinceLabel = this.selectedProvinceLabel || indirizzoProvincia
      const parts = [
        this.indirizzoViaCompleto,
        indirizzoCivico && `N. ${indirizzoCivico}`,
        indirizzoCap,
        indirizzoCitta,
        provinceLabel
      ].filter(Boolean)
      return parts.join(', ')
    },
    indirizzoResidenzaCompleto () {
      const residenzaProvinciaLabel = this.selectedResidenzaProvinceLabel || this.form.residenzaProvincia
      const parts = [
        [this.form.residenzaToponimo, this.form.residenzaVia].filter(Boolean).join(' '),
        this.form.residenzaCivico && `N. ${this.form.residenzaCivico}`,
        this.form.residenzaCap,
        this.form.residenzaCitta,
        residenzaProvinciaLabel
      ].filter(Boolean)
      return parts.join(', ')
    },
    indirizzoViaCompleto () {
      const toponimo = String(this.form.indirizzoToponimo || '').trim()
      const via = String(this.form.indirizzoVia || '').trim()
      return [toponimo, via].filter(Boolean).join(' ').trim()
    },
    selectedProvinceLabel () {
      const code = this.form.indirizzoProvincia
      if (!code) return ''
      const p = this.provinceOptions.find(x => String(this.getProvinceCode(x)) === String(code))
      return p?.name || this.getProvinceLabel(p) || code
    },
    selectedResidenzaProvinceLabel () {
      const code = this.form.residenzaProvincia
      if (!code) return ''
      const p = this.provinceOptions.find(x => String(this.getProvinceCode(x)) === String(code))
      return p?.name || this.getProvinceLabel(p) || code
    },
    filteredProvinceOptions () {
      const q = String(this.provinceSearch || '').trim().toLowerCase()
      if (!q) return this.provinceOptions
      return this.provinceOptions.filter(p => {
        const label = String(this.getProvinceLabel(p)).toLowerCase()
        const code = String(this.getProvinceCode(p)).toLowerCase()
        return label.includes(q) || code.includes(q)
      })
    },
    filteredCityOptions () {
      const q = String(this.citySearch || '').trim().toLowerCase()
      if (!q) return this.cityOptions
      return this.cityOptions.filter(c => {
        const label = String(this.getCityName(c)).toLowerCase()
        return label.includes(q)
      })
    },
    filteredResidenzaProvinceOptions () {
      const q = String(this.residenzaProvinceSearch || '').trim().toLowerCase()
      if (!q) return this.provinceOptions
      return this.provinceOptions.filter(p => {
        const label = String(this.getProvinceLabel(p)).toLowerCase()
        const code = String(this.getProvinceCode(p)).toLowerCase()
        return label.includes(q) || code.includes(q)
      })
    },
    filteredResidenzaCityOptions () {
      const q = String(this.residenzaCitySearch || '').trim().toLowerCase()
      if (!q) return this.residenzaCityOptions
      return this.residenzaCityOptions.filter(c => {
        const label = String(this.getCityName(c)).toLowerCase()
        return label.includes(q)
      })
    },
    otpResendButtonLabel () {
      if (this.otpResendLoading) return 'Invio...'
      if (this.otpResendCountdown > 0) {
        const sec = this.otpResendCountdown % 60
        const min = Math.floor(this.otpResendCountdown / 60)
        const mm = String(min).padStart(2, '0')
        const ss = String(sec).padStart(2, '0')
        return `Codice inviato (${mm}:${ss})`
      }
      return 'Reinvia codice'
    },
    isInviteExpiredError () {
      return String(this.criticalErrorMessage || '').toLowerCase().includes('scaduto')
    },
    criticalErrorTitle () {
      return this.isInviteExpiredError ? 'Codice scaduto' : 'Accesso non disponibile'
    },
    offertaLuce () {
      const list = Array.isArray(this.offerteAgf) ? this.offerteAgf : []
      return (
        list.find(o => o.type === 'ee') ||
        list.find(o => Number(o?.f1) > 0 && Number(o?.m) === 0) ||
        null
      )
    },
    offertaGas () {
      const list = Array.isArray(this.offerteAgf) ? this.offerteAgf : []
      return (
        list.find(o => o.type === 'gas') ||
        list.find(o => Number(o?.m) > 0) ||
        null
      )
    },
    offertaSelezionata () {
      if (this.selectedCommodity === 'luce') return this.offertaLuce
      if (this.selectedCommodity === 'gas') return this.offertaGas
      return null
    },
    offertaSelezionataNome () {
      return this.offertaSelezionata?.name_offerta || 'Offerta non disponibile'
    },
    offertaCombinataNome () {
      return this.offertaLuce?.name_offerta || this.offertaGas?.name_offerta || 'Offerta non disponibile'
    },
    prezzoLuce () {
      if (!this.offertaLuce) return '-'
      return `PUN + ${Number(this.offertaLuce.f1).toFixed(3).replace('.', ',')}€/kWh`
    },
    prezzoGas () {
      if (!this.offertaGas) return '-'
      return `PSV + ${Number(this.offertaGas.m).toFixed(3).replace('.', ',')}€/Smc`
    },
    offertaSelezionataPrezzo () {
      if (!this.offertaSelezionata) return '-'
      return this.selectedCommodity === 'luce' ? this.prezzoLuce : this.prezzoGas
    },
    offertaSelezionataPcv () {
      if (!this.offertaSelezionata) return '-'
      return `${this.offertaSelezionata.pcv}€/Mese`
    },
    pcvLuceGas () {
      const pcvLuce = this.offertaLuce ? `${this.offertaLuce.pcv}€/Mese` : '-'
      const pcvGas = this.offertaGas ? `${this.offertaGas.pcv}€/Mese` : '-'
      return `${pcvLuce} / ${pcvGas}`
    }
  },
  watch: {
    currentStep (next) {
      if (next === 2) {
        this.loadProvinceOptions().then(() => {
          if (this.form.residenzaProvincia) {
            this.residenzaProvinceSearch = this.selectedResidenzaProvinceLabel || this.form.residenzaProvincia
            this.loadResidenzaCitiesForProvince(this.form.residenzaProvincia)
          }
        })
        return
      }
      if (next !== 3) return
      this.loadProvinceOptions().then(() => {
        if (this.form.indirizzoProvincia) {
          this.provinceSearch = this.selectedProvinceLabel || this.form.indirizzoProvincia
          this.loadCitiesForProvince(this.form.indirizzoProvincia)
        }
      })
      if (!this.residenzaDialogHandled) this.showResidenzaDialog = true
    }
  },
  beforeUnmount () {
    this.stopOtpResendCountdown()
  },
  methods: {
    async loadOfferteAgf () {
      const token = this.$route.params.token
      if (!token) return
      try {
        const res = await this.$service.get_offerte_agf(token)
        const raw = res?.items || []
        if (Array.isArray(raw)) {
          this.offerteAgf = raw
        } else if (raw && Array.isArray(raw.items)) {
          this.offerteAgf = raw.items
        } else {
         
          const values = raw && typeof raw === 'object' ? Object.values(raw) : []
          const maybeArr = values.find(v => Array.isArray(v))
          this.offerteAgf = maybeArr || []
        }

        const hasLuce = this.offerteAgf?.some(o => o?.type === 'ee')
        const hasGas = this.offerteAgf?.some(o => o?.type === 'gas')

        if (this.selectedCommodity === 'luce' && !hasLuce && hasGas) this.selectedCommodity = 'gas'
        if (this.selectedCommodity === 'gas' && !hasGas && hasLuce) this.selectedCommodity = 'luce'
        if (this.selectedCommodity === 'lucegas' && (!hasLuce || !hasGas)) {
          this.selectedCommodity = hasLuce ? 'luce' : 'gas'
        }
      } catch (e) {
        // noop
      }
    },
    async initSessionDraft () {
      const token = this.getToken()
      const inviteCode = this.getInviteCode()
      if (!token) return
      try {
        const res = await this.$service.save_wizard_step({
          token,
          step: 1,
          selectedCommodity: undefined,
          invite_code: inviteCode || undefined,
          form: {},
          data: undefined
        })
        const data = res?.items || {}
        if (data?.session_id) this.sessionId = data.session_id
      } catch (e) {
        // noop
      }
    },
    getProvinceCode (p) {
      return p?.code ?? p?.sigla ?? p?.cod_provincia ?? p?.id ?? ''
    },
    getProvinceLabel (p) {
      return p?.name ?? p?.provincia ?? p?.denominazione ?? ''
    },
    getProvinceKey (p) {
      return this.getProvinceCode(p) || this.getProvinceLabel(p) || ''
    },
    getCityName (c) {
      return c?.name ?? c?.comune ?? c?.city ?? c?.denominazione ?? ''
    },
    getTipoOffertaLabel (offerta) {
      const tipo = Number(offerta?.type_offerta)
      if (tipo === 1) return 'Fissa'
      if (tipo === 2) return 'Variabile'
      return 'Tipo offerta non specificato'
    },
    getCityKey (c) {
      return c?.id ?? c?.codice ?? c?.cod_comune ?? c?.codice_comune ?? c?.istat ?? this.getCityName(c)
    },
    async loadProvinceOptions () {
      if (this.provinceOptions.length > 0) return
      this.isLoadingProvinces = true
      try {
        const res = await this.$service.getDistricts()
        const items = res?.items || []
        this.provinceOptions = Array.isArray(items) ? items : []
      } catch (e) {
        this.provinceOptions = []
      } finally {
        this.isLoadingProvinces = false
      }
    },
    async loadCitiesForProvince (provinceCode) {
      if (!provinceCode) {
        this.cityOptions = []
        this.cityDropdownOpen = false
        return
      }
      this.isLoadingCities = true
      try {
        const res = await this.$service.getCities(provinceCode)
        const items = res?.items || []
        this.cityOptions = Array.isArray(items) ? items : []
      } catch (e) {
        this.cityOptions = []
      } finally {
        this.isLoadingCities = false
      }
    },
    async loadResidenzaCitiesForProvince (provinceCode) {
      if (!provinceCode) {
        this.residenzaCityOptions = []
        this.residenzaCityDropdownOpen = false
        return
      }
      this.isLoadingCities = true
      try {
        const res = await this.$service.getCities(provinceCode)
        const items = res?.items || []
        this.residenzaCityOptions = Array.isArray(items) ? items : []
      } catch (e) {
        this.residenzaCityOptions = []
      } finally {
        this.isLoadingCities = false
      }
    },
    async openProvinceDropdown () {
      await this.loadProvinceOptions()
      this.provinceDropdownOpen = true
    },
    closeProvinceDropdown () {
      setTimeout(() => {
        this.provinceDropdownOpen = false
      }, 120)
    },
    async openCityDropdown () {
      if (!this.form.indirizzoProvincia) return
      if (this.cityOptions.length === 0) {
        await this.loadCitiesForProvince(this.form.indirizzoProvincia)
      }
      this.cityDropdownOpen = true
    },
    closeCityDropdown () {
      setTimeout(() => {
        this.cityDropdownOpen = false
      }, 120)
    },
    async openResidenzaProvinceDropdown () {
      await this.loadProvinceOptions()
      this.residenzaProvinceDropdownOpen = true
    },
    closeResidenzaProvinceDropdown () {
      setTimeout(() => {
        this.residenzaProvinceDropdownOpen = false
      }, 120)
    },
    async openResidenzaCityDropdown () {
      if (!this.form.residenzaProvincia) return
      if (this.residenzaCityOptions.length === 0) {
        await this.loadResidenzaCitiesForProvince(this.form.residenzaProvincia)
      }
      this.residenzaCityDropdownOpen = true
    },
    closeResidenzaCityDropdown () {
      setTimeout(() => {
        this.residenzaCityDropdownOpen = false
      }, 120)
    },
    onProvinceSearchInput () {
      const selectedLabel = this.selectedProvinceLabel
      if (this.provinceSearch !== selectedLabel) {
        this.form.indirizzoProvincia = ''
        this.form.indirizzoCitta = ''
        this.form.indirizzoCittaId = ''
        this.cityOptions = []
        this.citySearch = ''
        this.cityDropdownOpen = false
      }
    },
    onResidenzaProvinceSearchInput () {
      const selectedLabel = this.selectedResidenzaProvinceLabel
      if (this.residenzaProvinceSearch !== selectedLabel) {
        this.form.residenzaProvincia = ''
        this.form.residenzaCitta = ''
        this.form.residenzaCittaId = ''
        this.residenzaCityOptions = []
        this.residenzaCitySearch = ''
        this.residenzaCityDropdownOpen = false
      }
    },
    onCitySearchInput () {
      const selectedCity = this.citySearch
      if (String(this.form.indirizzoCitta || '') !== String(selectedCity || '')) {
        this.form.indirizzoCitta = ''
        this.form.indirizzoCittaId = ''
      }
    },
    onResidenzaCitySearchInput () {
      const selectedCity = this.residenzaCitySearch
      if (String(this.form.residenzaCitta || '') !== String(selectedCity || '')) {
        this.form.residenzaCitta = ''
        this.form.residenzaCittaId = ''
      }
    },
    async selectProvince (p) {
      const code = this.getProvinceCode(p)
      const label = this.getProvinceLabel(p) || code
      this.form.indirizzoProvincia = String(code || '')
      this.provinceSearch = label
      this.provinceDropdownOpen = false

      this.form.indirizzoCitta = ''
      this.form.indirizzoCittaId = ''
      this.citySearch = ''
      this.cityOptions = []
      this.cityDropdownOpen = false
      await this.loadCitiesForProvince(this.form.indirizzoProvincia)
    },
    selectCity (c) {
      const name = this.getCityName(c)
      this.form.indirizzoCitta = name
      this.form.indirizzoCittaId = String(this.getCityKey(c) ?? '')
      this.citySearch = name
      this.cityDropdownOpen = false
    },
    async selectResidenzaProvince (p) {
      const code = this.getProvinceCode(p)
      const label = this.getProvinceLabel(p) || code
      this.form.residenzaProvincia = String(code || '')
      this.residenzaProvinceSearch = label
      this.residenzaProvinceDropdownOpen = false

      this.form.residenzaCitta = ''
      this.form.residenzaCittaId = ''
      this.residenzaCitySearch = ''
      this.residenzaCityOptions = []
      this.residenzaCityDropdownOpen = false
      await this.loadResidenzaCitiesForProvince(this.form.residenzaProvincia)
    },
    selectResidenzaCity (c) {
      const name = this.getCityName(c)
      this.form.residenzaCitta = name
      this.form.residenzaCittaId = String(this.getCityKey(c) ?? '')
      this.residenzaCitySearch = name
      this.residenzaCityDropdownOpen = false
    },
    getToken () {
      return this.$route?.params?.token || ''
    },
    getInviteCode () {
      const refFromQuery = String(this.$route?.query?.ref || '').trim()
      if (refFromQuery) return refFromQuery
      return this.getToken()
    },
    showBlockingError (message) {
      this.criticalErrorMessage = message || 'è stato riscontrato un problema, ricaricare la pagina'
      this.showCriticalError = true
    },
    reloadPage () {
      window.location.reload()
    },
    async verifyInviteCode () {
      const ref = this.getInviteCode()
      const token = this.getToken()
      if (!ref) {
        this.showBlockingError()
        this.inviteChecked = true
        return false
      }
      try {
        const res = await this.$service.verify_invite_code({
          invite_code: ref,
          ref,
          token,
          session_id: this.sessionId || undefined
        })
        const data = res?.items || {}
        const isValid = data?.valid === true && data?.error === false
        if (!isValid) {
          this.showBlockingError(data?.msg || 'Codice invito non valido')
          this.inviteChecked = true
          return false
        }
        if (data?.session_id) this.sessionId = data.session_id
        this.inviteChecked = true
        return true
      } catch (e) {
        const backendMsg = e?.response?.data?.msg
        this.showBlockingError(backendMsg)
        this.inviteChecked = true
        return false
      }
    },
    cleanStepPayload (payload) {
      if (!payload || typeof payload !== 'object') return {}
      const cleaned = {}
      Object.entries(payload).forEach(([k, v]) => {
        if (v === null || v === undefined) return
        if (typeof v === 'string' && v.trim() === '') return
        cleaned[k] = v
      })
      return cleaned
    },
    stepPayload (step) {
      if (step === 1) return null
      if (step === 2) {
        return this.cleanStepPayload({
          nome: this.form.nome,
          cognome: this.form.cognome,
          email: this.form.email,
          telefono: this.form.telefono,
          codiceFiscale: this.form.codiceFiscale,
          documentoIdentita: this.form.documentoIdentita,
          documentoIdentitaNome: this.form.documentoIdentitaNome,
          residenzaToponimo: this.form.residenzaToponimo,
          residenzaVia: this.form.residenzaVia,
          residenzaCivico: this.form.residenzaCivico,
          residenzaCap: this.form.residenzaCap,
          residenzaCitta: this.form.residenzaCitta,
          residenzaCittaId: this.form.residenzaCittaId,
          cod_comune_cliente: this.form.residenzaCittaId,
          residenzaProvincia: this.form.residenzaProvincia,
          premi: this.form.premi,
          esigenze: this.form.esigenze
        })
      }
      if (step === 3) {
        const payload = this.cleanStepPayload({
          residenzaUguale: this.form.residenzaUguale,
          indirizzoResidenza: this.form.indirizzoResidenza,
          indirizzoToponimo: this.form.indirizzoToponimo,
          indirizzoVia: this.form.indirizzoVia,
          indirizzoCivico: this.form.indirizzoCivico,
          indirizzoCap: this.form.indirizzoCap,
          indirizzoCitta: this.form.indirizzoCitta,
          indirizzoCittaId: this.form.indirizzoCittaId,
          cod_comune_fornitura: this.form.indirizzoCittaId,
          indirizzoProvincia: this.form.indirizzoProvincia,
          pod: this.form.pod,
          pdr: this.form.pdr,
          fornituraTipo: this.form.fornituraTipo,
          ultimaBolletta: this.form.ultimaBolletta,
          ultimaBollettaNome: this.form.ultimaBollettaNome,
          intestatarioLuce: this.form.intestatarioLuce,
          intestatarioGas: this.form.intestatarioGas,
          codiceFiscaleIntestatarioLuce: this.form.codiceFiscaleIntestatarioLuce,
          codiceFiscaleIntestatarioGas: this.form.codiceFiscaleIntestatarioGas,
          autoletturaLuce: this.form.autoletturaLuce,
          autoletturaGas: this.form.autoletturaGas
        })
        
        payload.pratica = this.getPraticaValue()
        return payload
      }
      if (step === 4) {
        return this.cleanStepPayload({
          metodoPagamento: this.form.metodoPagamento,
          intestatarioConto: this.form.intestatarioConto,
          iban: this.form.iban
        })
      }
      if (step === 5) {
        return this.cleanStepPayload({
          consensoClienteSoddisfazione: this.form.consensoClienteSoddisfazione,
          consensoClientePromo: this.form.consensoClientePromo,
          consensoClienteMarketing: this.form.consensoClienteMarketing,
          consensoTerziSoddisfazione: this.form.consensoTerziSoddisfazione,
          consensoTerziPromo: this.form.consensoTerziPromo,
          consensoTerziMarketing: this.form.consensoTerziMarketing,
          accettaEsecuzione: this.form.accettaEsecuzione,
          accettaCondizioni: this.form.accettaCondizioni,
          accettaClausole: this.form.accettaClausole
        })
      }
      return null
    },
    getPraticaValue () {
      const needsLuce = this.selectedCommodity === 'luce' || this.selectedCommodity === 'lucegas'
      const needsGas = this.selectedCommodity === 'gas' || this.selectedCommodity === 'lucegas'
      const isVolturaLuce = needsLuce && this.form.intestatarioLuce === 'no'
      const isVolturaGas = needsGas && this.form.intestatarioGas === 'no'
      return (isVolturaLuce || isVolturaGas) ? 'Voltura' : null
    },
    async persistStep (step, data = null) {
      const token = this.getToken()
      const inviteCode = this.getInviteCode()
      if (!token) return false
      try {
        const payloadForm = data || {}
        await this.$service.save_wizard_step({
          token,
          step,
          selectedCommodity: this.selectedCommodity,
          session_id: this.sessionId || undefined,
          invite_code: inviteCode || undefined,
          form: payloadForm,
          data: undefined
        })
        return true
      } catch (e) {
        return false
      }
    },
    async selectTariff (commodity) {
      this.selectedCommodity = commodity
      this.showPodInfo = false
      this.showPdrInfo = false
      await this.persistStep(1, null)
      this.currentStep = 2
    },
    clearStep2Errors () {
      this.step2Errors = {}
      this.step2ErrorList = []
    },
    validateEmail (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email)
    },
    normalizePhone (phone) {
      return String(phone || '').replace(/\D/g, '')
    },
    onDocumentoIdentitaChange (event) {
      const file = event?.target?.files?.[0] || null
      this.form.documentoIdentita = file
      this.form.documentoIdentitaNome = file?.name || ''
    },
    validateCodiceFiscale (cf) {
      const normalized = String(cf || '').replace(/\s/g, '').toUpperCase()
      return /^[A-Z0-9]{16}$/.test(normalized)
    },
    validateStep2 () {
      this.clearStep2Errors()
      const errors = {}
      const list = []

      const nome = (this.form.nome || '').trim()
      const cognome = (this.form.cognome || '').trim()
      const email = (this.form.email || '').trim()
      const telefonoNorm = this.normalizePhone(this.form.telefono)
      const cfNorm = String(this.form.codiceFiscale || '').replace(/\s/g, '').toUpperCase()

      if (!nome) { errors.nome = 'Inserisci il nome'; list.push(errors.nome) }
      if (!cognome) { errors.cognome = 'Inserisci il cognome'; list.push(errors.cognome) }
      if (!email) { errors.email = 'Inserisci l’email'; list.push(errors.email) }
      else if (!this.validateEmail(email)) { errors.email = 'Inserisci un’email valida'; list.push(errors.email) }

      if (!telefonoNorm) { errors.telefono = 'Inserisci il numero di telefono'; list.push(errors.telefono) }
      else if (telefonoNorm.length < 8) { errors.telefono = 'Inserisci un numero di telefono valido'; list.push(errors.telefono) }

      if (!cfNorm) { errors.codiceFiscale = 'Inserisci il codice fiscale'; list.push(errors.codiceFiscale) }
      else if (!this.validateCodiceFiscale(cfNorm)) { errors.codiceFiscale = 'Il codice fiscale deve contenere 16 caratteri alfanumerici'; list.push(errors.codiceFiscale) }
      if (!this.form.documentoIdentita) {
        errors.documentoIdentita = 'Carica il documento d’identità'
        list.push(errors.documentoIdentita)
      }
      const resToponimo = String(this.form.residenzaToponimo || '').trim()
      const resVia = String(this.form.residenzaVia || '').trim()
      const resCivico = String(this.form.residenzaCivico || '').trim()
      const resCap = String(this.form.residenzaCap || '').trim()
      const resCitta = String(this.form.residenzaCitta || '').trim()
      const resProvincia = String(this.form.residenzaProvincia || '').trim()

      if (!resToponimo) { errors.residenzaToponimo = 'Seleziona il toponimo di residenza'; list.push(errors.residenzaToponimo) }
      if (!resVia) { errors.residenzaVia = 'Inserisci la via di residenza'; list.push(errors.residenzaVia) }
      if (!resCivico) { errors.residenzaCivico = 'Inserisci il civico di residenza'; list.push(errors.residenzaCivico) }
      if (!resCap || !this.validateCap(resCap)) { errors.residenzaCap = 'Inserisci un CAP residenza valido (5 cifre)'; list.push(errors.residenzaCap) }
      if (!resCitta) { errors.residenzaCitta = 'Inserisci il comune diresidenza'; list.push(errors.residenzaCitta) }
      if (!resProvincia) { errors.residenzaProvincia = 'Inserisci la provincia di residenza'; list.push(errors.residenzaProvincia) }

      this.form.codiceFiscale = cfNorm
      this.step2Errors = errors
      this.step2ErrorList = list
      return list.length === 0
    },
    clearStep3Errors () {
      this.step3Errors = {}
      this.step3ErrorList = []
    },
    validatePod (pod) {
      const v = String(pod || '').trim().toUpperCase()
      
      return /^IT[A-Z0-9]{12}$/.test(v)
    },
    validatePdr (pdr) {
      const digits = String(pdr || '').replace(/\D/g, '')
      return digits.length === 14
    },
    validateCap (cap) {
      return /^\d{5}$/.test(String(cap || '').trim())
    },
    onUltimaBollettaChange (event) {
      const file = event?.target?.files?.[0] || null
      this.form.ultimaBolletta = file
      this.form.ultimaBollettaNome = file?.name || ''
    },
    async onResidenzaDialogChoice (isSame) {
      this.form.residenzaUguale = isSame
      this.residenzaDialogHandled = true
      this.showResidenzaDialog = false

      if (!isSame) {
        this.form.indirizzoToponimo = ''
        this.form.indirizzoVia = ''
        this.form.indirizzoCivico = ''
        this.form.indirizzoCap = ''
        this.form.indirizzoProvincia = ''
        this.form.indirizzoCitta = ''
        this.form.indirizzoCittaId = ''
        this.provinceSearch = ''
        this.citySearch = ''
        this.cityOptions = []
        this.cityDropdownOpen = false
        return
      }

      this.form.indirizzoToponimo = this.form.residenzaToponimo || this.form.indirizzoToponimo
      this.form.indirizzoVia = this.form.residenzaVia || this.form.indirizzoVia
      this.form.indirizzoCivico = this.form.residenzaCivico || this.form.indirizzoCivico
      this.form.indirizzoCap = this.form.residenzaCap || this.form.indirizzoCap
      this.form.indirizzoProvincia = this.form.residenzaProvincia || this.form.indirizzoProvincia
      this.form.indirizzoCitta = this.form.residenzaCitta || this.form.indirizzoCitta
      this.form.indirizzoCittaId = this.form.residenzaCittaId || this.form.indirizzoCittaId

      this.provinceSearch = this.selectedProvinceLabel || this.form.indirizzoProvincia
      if (this.form.indirizzoProvincia) {
        await this.loadCitiesForProvince(this.form.indirizzoProvincia)
      }
      this.citySearch = this.form.indirizzoCitta || ''
    },
    validateStep3 () {
      this.clearStep3Errors()
      const errors = {}
      const list = []

      const indirizzoToponimo = String(this.form.indirizzoToponimo || '').trim()
      const indirizzoVia = String(this.form.indirizzoVia || '').trim()
      const indirizzoCivico = String(this.form.indirizzoCivico || '').trim()
      const indirizzoCap = String(this.form.indirizzoCap || '').trim()
      const indirizzoCitta = String(this.form.indirizzoCitta || '').trim()
      const indirizzoProvincia = String(this.form.indirizzoProvincia || '').trim()

      if (!indirizzoToponimo) { errors.indirizzoToponimo = 'Seleziona il toponimo.'; list.push(errors.indirizzoToponimo) }
      if (!indirizzoVia) { errors.indirizzoVia = 'Inserisci l’indirizzo di fornitura.'; list.push(errors.indirizzoVia) }
      if (!indirizzoCivico) { errors.indirizzoCivico = 'Inserisci il numero civico.'; list.push(errors.indirizzoCivico) }
      if (!indirizzoCap || !this.validateCap(indirizzoCap)) { errors.indirizzoCap = 'Inserisci un CAP valido (5 cifre).'; list.push(errors.indirizzoCap) }
      if (!indirizzoCitta) { errors.indirizzoCitta = 'Inserisci il comune.'; list.push(errors.indirizzoCitta) }
      if (!indirizzoProvincia) { errors.indirizzoProvincia = 'Inserisci la provincia.'; list.push(errors.indirizzoProvincia) }
      if (!['1', '2', '3'].includes(String(this.form.fornituraTipo || ''))) {
        errors.fornituraTipo = 'Seleziona il tipo di fornitura.'
        list.push(errors.fornituraTipo);
      }
      if (!this.form.ultimaBolletta) {
        errors.ultimaBolletta = 'Carica il file dell’ultima bolletta.'
        list.push(errors.ultimaBolletta)
      }
      
      const needsLuce = this.selectedCommodity === 'luce' || this.selectedCommodity === 'lucegas'
      const needsGas = this.selectedCommodity === 'gas' || this.selectedCommodity === 'lucegas'

      if (needsLuce) {
        if (!this.validatePod(this.form.pod)) {
          errors.pod = 'Inserisci un POD luce valido (IT + 14 caratteri totali).'
          list.push(errors.pod)
        }

        if (this.form.intestatarioLuce === 'no') {
          const cfLuceNorm = String(this.form.codiceFiscaleIntestatarioLuce || '')
            .replace(/\s/g, '')
            .toUpperCase()
          this.form.codiceFiscaleIntestatarioLuce = cfLuceNorm
          if (!this.validateCodiceFiscale(cfLuceNorm)) {
            errors.codiceFiscaleIntestatarioLuce = 'Inserisci un codice fiscale intestatario luce valido.'
            list.push(errors.codiceFiscaleIntestatarioLuce)
          }
        }
      }

      if (needsGas) {
        if (!this.validatePdr(this.form.pdr)) {
          errors.pdr = 'Inserisci un PDR gas valido (14 numeri).'
          list.push(errors.pdr)
        }

        if (this.form.intestatarioGas === 'no') {
          const cfGasNorm = String(this.form.codiceFiscaleIntestatarioGas || '')
            .replace(/\s/g, '')
            .toUpperCase()
          this.form.codiceFiscaleIntestatarioGas = cfGasNorm
          if (!this.validateCodiceFiscale(cfGasNorm)) {
            errors.codiceFiscaleIntestatarioGas = 'Inserisci un codice fiscale intestatario gas valido.'
            list.push(errors.codiceFiscaleIntestatarioGas)
          }
        }
      }

      this.step3Errors = errors
      this.step3ErrorList = list
      return list.length === 0
    },
    clearStep4Errors () {
      this.step4Errors = {}
    },
    validateIban (iban) {
      const v = String(iban || '').replace(/\s/g, '').toUpperCase()
      if (!/^[A-Z0-9]{15,34}$/.test(v)) return false

      const rearranged = v.slice(4) + v.slice(0, 4)
      let numeric = ''
      for (let i = 0; i < rearranged.length; i += 1) {
        const ch = rearranged[i]
        if (/[A-Z]/.test(ch)) numeric += String(ch.charCodeAt(0) - 55)
        else numeric += ch
      }
      let remainder = 0
      for (let i = 0; i < numeric.length; i += 1) {
        remainder = (remainder * 10 + Number(numeric[i])) % 97
      }

      return remainder === 1
    },
    validateStep4 () {
      this.clearStep4Errors()
      const errors = {}

      const intestatarioConto = String(this.form.intestatarioConto || '').trim()
      const ibanRaw = String(this.form.iban || '')
      const ibanNorm = ibanRaw.replace(/\s/g, '').toUpperCase()

      if (!intestatarioConto) errors.intestatarioConto = 'Inserisci il nome dell’intestatario del conto.'
      if (!ibanNorm) errors.iban = 'Inserisci un IBAN.'
      else if (!this.validateIban(ibanNorm)) errors.iban = 'Inserisci un IBAN valido.'

      this.form.iban = ibanNorm
      this.step4Errors = errors
      return Object.keys(errors).length === 0
    },
    async goNext () {
      if (this.currentStep === 2) {
        const ok = this.validateStep2()
        if (!ok) return
      }
      if (this.currentStep === 3) {
        const ok = this.validateStep3()
        if (!ok) return
      }
      if (this.currentStep === 4) {
        const ok = this.validateStep4()
        if (!ok) return
      }
      if (this.currentStep < this.steps.length) {
        const ok = await this.persistStep(this.currentStep, this.stepPayload(this.currentStep))
        if (!ok) {
          this.showCriticalError = true
          return
        }
        this.currentStep += 1
      }
    },

    canPersistStep4 () {
      const intestatarioConto = String(this.form.intestatarioConto || '').trim()
      const ibanNorm = String(this.form.iban || '').replace(/\s/g, '').toUpperCase()
      return Boolean(intestatarioConto && ibanNorm && this.validateIban(ibanNorm))
    },
    async goPrev () {
      if (this.currentStep > 1) {
        if (this.currentStep === this.steps.length) {
          if (this.identityOtpVerified) {
            await this.persistStep(this.currentStep, this.stepPayload(this.currentStep))
          } else {
            this.identityOtpRequested = false
            this.identityOtpVerified = false
            this.otpCode = ''
            this.otpError = ''
            this.otpExpiresAt = null
            this.otpSessionId = ''
            this.otpResendLoading = false
            this.stopOtpResendCountdown()
          }
        } else {
          const shouldPersistStep = !(this.currentStep === 4 && !this.canPersistStep4())
          if (shouldPersistStep) {
            await this.persistStep(this.currentStep, this.stepPayload(this.currentStep))
          }
        }
        this.currentStep -= 1
      }
    },
    stopOtpResendCountdown () {
      if (this.otpResendTimerId) {
        clearInterval(this.otpResendTimerId)
        this.otpResendTimerId = null
      }
      this.otpResendCountdown = 0
    },
    startOtpResendCountdown (seconds = 60) {
      this.stopOtpResendCountdown()
      this.otpResendCountdown = Number(seconds) || 60
      this.otpResendTimerId = setInterval(() => {
        if (this.otpResendCountdown <= 1) {
          this.stopOtpResendCountdown()
          return
        }
        this.otpResendCountdown -= 1
      }, 1000)
    },
    async requestOtp (mode = 'initial') {
      this.showStep5Errors = true
      this.otpError = ''
      this.otpCode = ''
      this.otpSessionId = ''
      if (mode === 'resend') this.otpResendLoading = true

      const token = this.getToken()
      const telefono = this.normalizePhone(this.form.telefono)
      if (!token || !telefono) {
        this.otpError = 'Token o telefono non validi'
        this.otpResendLoading = false
        return
      }

      try {
        const res = await this.$service.request_phone_otp({ token, telefono })
        const data = res?.items || {}
        if (!data || Object.keys(data).length === 0 || data?.error || data?.verified === false) {
          this.otpError = data?.msg || 'Errore richiesta OTP'
          this.identityOtpRequested = false
          return
        }

        this.identityOtpRequested = true
        this.identityOtpVerified = false
        this.otpExpiresAt = data?.expires_at || null
        this.otpSessionId = data?.session_id || ''

        if (mode === 'resend') {
          this.startOtpResendCountdown(60)
        }
      } finally {
        this.otpResendLoading = false
      }
    },

    async verifyOtp () {
      this.otpError = ''

      const otp = String(this.otpCode || '').trim()
      if (!/^\d{6}$/.test(otp)) {
        this.otpError = 'OTP non valido'
        return
      }

      const token = this.getToken()
      const telefono = this.normalizePhone(this.form.telefono)
      if (!token || !telefono) {
        this.otpError = 'Token o telefono non validi'
        return
      }

      if (!this.otpSessionId) {
        this.otpError = 'Richiedi un nuovo codice (OTP).'
        return
      }

      const res = await this.$service.verify_phone_otp({
        token,
        otp,
        telefono,
        session_id: this.otpSessionId
      })
      const data = res?.items || {}

      if (data?.verified) {
        this.identityOtpVerified = true
        this.identityOtpRequested = true
        this.otpError = ''
      } else {
        this.identityOtpVerified = false
        this.identityOtpRequested = true
        this.otpError = data?.msg || 'OTP errato o scaduto'
      }
    },
    togglePodInfo () {
      this.showPodInfo = !this.showPodInfo
    },
    togglePdrInfo () {
      this.showPdrInfo = !this.showPdrInfo
    },
    async confirm () {
      this.showStep5Errors = true
      if (!this.identityOtpVerified) return
      if (this.isSubmittingCompletedWizard) return
      const ok = await this.persistStep(5, this.stepPayload(5))
      if (!ok) {
        this.showBlockingError()
        return
      }
      const token = this.getToken()
      if (!token) {
        this.showBlockingError()
        return
      }

      this.isSubmittingCompletedWizard = true
      try {
        const submitRes = await this.$service.submit_completed_wizard({
          token,
          session_id: this.sessionId || undefined,
          fileBolletta: this.form.ultimaBolletta || undefined,
          documentoIdentita: this.form.documentoIdentita || undefined,
          cellulare: this.form.telefono || undefined,
          email: this.form.email || undefined,
          cod_comune_cliente: this.form.residenzaCittaId || undefined,
          cod_comune_fornitura: this.form.indirizzoCittaId || undefined
        })
        const submitData = submitRes?.items || {}
        if (submitData?.error) {
          this.showBlockingError(submitData?.msg)
          return
        }

        const res = await this.$service.send_summary_email({
          token,
          session_id: this.sessionId || undefined
        })
        const data = res?.items || {}
        if (data?.error) {
          this.showBlockingError(data?.msg)
          return
        }
      } catch (e) {
        const backendMsg = e?.response?.data?.msg
        this.showBlockingError(backendMsg)
        return
      } finally {
        this.isSubmittingCompletedWizard = false
      }

      this.showFinalThanks = true
    }
  },
  setup () {
    const self = getCurrentInstance()
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    self.proxy.$service = service

    onMounted(async () => {
      const isInviteValid = await self.proxy.verifyInviteCode()
      if (!isInviteValid) return

      await Promise.all([
        self.proxy.loadOfferteAgf(),
        self.proxy.initSessionDraft()
      ])
    })
  }
}
</script>

<style scoped>
.agf-wizard {
  min-height: 100vh;
  padding: 32px 16px 32px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbf1 40%, #edf7dd 100%);
  color: #1f2933;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
}

.wizard-header {
  max-width: 400px;
  margin: 0 auto -50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.wizard-logo-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.wizard-logo {
  max-width: 350px;
  width: 100%;
  height: auto;
}

.wizard-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
}

.wizard-step {
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 0 0 auto;
  position: relative;
}

.wizard-step--active .wizard-step-label {
  color: #111827;
  font-weight: 600;
}

.wizard-step--done .wizard-step-label {
  color: #4b5563;
}

.wizard-step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #93c04a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-color: transparent;
  color: #51752a;
  z-index: 1;
}

.wizard-step-circle--active {
  background: #93c04a;
  border-color: #93c04a;
  color: #ffffff;
}

.wizard-step-circle--done {
  background: #2cc9d1;
  border-color: #2cc9d1;
  color: #ffffff;
}

.wizard-step-label {
  margin-top: 6px;
  font-size: 12px;
  white-space: nowrap;
  color: #6b7280;
}

.wizard-step-line {
  position: absolute;
  left: calc(73% + 18px); 
  right: auto;
  width: 35px; 
  height: 2px;
  background: #93c04a;
  top: 16px;
  transform: translateY(-50%);
  z-index: 0;
}

.wizard-step-line--active {
  background: #2cc9d1;
}

.wizard-main {
  max-width: 1440px;
  margin: 70px auto 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}

.wizard-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 24px 28px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 780px;
}

.wizard-card--secondary {
  border-style: dashed;
  border-color: #93c04a;
}

.wizard-card--narrow {
  max-width: 720px;
}

.wizard-card--wide {
  max-width: 1040px;
  padding: 32px 32px 36px;
}

.wizard-card--xwide {
  width: 100%;
  max-width: none;
  padding-left: 24px;
  padding-right: 24px;
}

.wizard-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 16px;
}

.wizard-info-box {
  margin-bottom: 20px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(147, 192, 74, 0.45);
  background: linear-gradient(135deg, rgba(147, 192, 74, 0.12) 0%, rgba(44, 201, 209, 0.08) 100%);
}

.wizard-info-box-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #3f5f22;
}

.wizard-info-box-text {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.45;
  color: #374151;
}

.wizard-info-box-list {
  margin: 0;
  padding-left: 18px;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
}

.wizard-info-box-list li + li {
  margin-top: 4px;
}

.wizard-info-box-list strong {
  color: #2f4a18;
  font-weight: 700;
}

.wizard-subtitle {
  font-size: 18px;
  font-weight: 600;
  margin: 24px 0 8px;
}

.wizard-text {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
}

.wizard-text--compact {
  margin-top: 6px;
  margin-bottom: 10px;
  font-size: 13px;
}

.wizard-validation {
  margin: 10px 0 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(239, 68, 68, 0.25);
  background: rgba(239, 68, 68, 0.06);
}

.wizard-error-text {
  color: #b91c1c;
  font-size: 13px;
  line-height: 1.35;
  margin: 0;
}

.wizard-field-error {
  color: #b91c1c;
  font-size: 12px;
  line-height: 1.25;
  margin-top: 6px;
}

.wizard-otp-panel {
  margin-top: 16px;
  padding-top: 8px;
}

.wizard-dialog-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.35);
  z-index: 1000;
  display: grid;
  place-items: center;
  padding: 16px;
}

.wizard-dialog {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
  padding: 18px 18px 16px;
}

.wizard-dialog-actions {
  margin-top: 14px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.wizard-dialog-btn {
  min-width: 88px;
  height: 40px;
  border: none;
  border-radius: 999px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease;
}

.wizard-dialog-btn:hover {
  transform: translateY(-1px);
}

.wizard-dialog-btn--yes {
  background: linear-gradient(135deg, #93c04a, #2cc9d1);
  color: #ffffff;
  box-shadow: 0 10px 24px rgba(44, 201, 209, 0.28);
}

.wizard-dialog-btn--no {
  background: #ffffff;
  color: #4b5563;
  border: 1px solid #d1d5db;
  box-shadow: 0 6px 14px rgba(17, 24, 39, 0.08);
}

.wizard-field-inline {
  display: flex;
  flex-direction: column;
}

.wizard-field-inline--full {
  grid-column: 1 / -1;
}

.wizard-field-inline--address {
  grid-column: span 4;
}

.wizard-offer-summary {
  margin-top: 16px;
  padding: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(147, 192, 74, 0.08), rgba(44, 201, 209, 0.04));
}

.wizard-offer-cards {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}

.offer-card {
  flex: 1 1 100%;
  max-width: 1040px;
  background: linear-gradient(135deg, rgba(147, 192, 74, 0.16), rgba(44, 201, 209, 0.16));
  border-radius: 18px;
  padding: 22px 22px 24px;
  color: #1f2933;
  position: relative;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(147, 192, 74, 0.35);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.offer-card--selected {
  border-color: rgba(147, 192, 74, 0.9);
  box-shadow: 0 18px 36px rgba(147, 192, 74, 0.25);
  transform: translateY(-2px);
}

.offer-card--combined {
  flex-basis: 100%;
  max-width: 1200px;
}

.offer-card-badge-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.offer-card-badge-row .offer-card-badge {
  position: static;
  top: auto;
  right: auto;
}

.offer-card-badge {
  position: absolute;
  top: 12px;
  right: 14px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(147, 192, 74, 0.18);
  font-size: 11px;
  font-weight: 600;
  color: #365314;
}

.offer-card-title {
  margin-top: 18px;
  font-size: 18px;
  font-weight: 600;
}

.offer-card-type {
  display: inline-flex;
  align-items: center;
  margin: 4px 0 10px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #365314;
  background: rgba(147, 192, 74, 0.16);
  border: 1px solid rgba(147, 192, 74, 0.42);
}

.offer-card-type--top {
  margin: 0;
  padding: 3px 8px;
  font-size: 10px;
}

.offer-card-type--small {
  margin: 3px 0 8px;
  font-size: 10px;
  padding: 3px 8px;
}

.offer-card-subtitle {
  margin: 2px 0 10px;
  font-size: 12px;
  color: #4b5563;
}

.offer-card-price {
  font-size: 26px;
  font-weight: 800;
  margin-bottom: 6px;
  color: #2f855a;
  letter-spacing: 0.01em;
}

.offer-card-price-small {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #2f855a;
}

.offer-card-pcv {
  font-size: 13px;
  margin-bottom: 14px;
}

.offer-card-cta {
  width: 100%;
  border: none;
  border-radius: 999px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #93c04a, #2cc9d1);
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.offer-card-combined-row {
  display: flex;
  gap: 12px;
  margin-top: 14px;
  margin-bottom: 18px;
}

.offer-card-side {
  flex: 1;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 14px;
  padding: 10px 12px;
  border: 1px solid rgba(147, 192, 74, 0.3);
}

.offer-card-tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 4px;
}

.offer-tag-pill {
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  color: #4b5563;
  border: 1px solid rgba(147, 192, 74, 0.3);
}

@media (max-width: 768px) {
  .wizard-offer-cards {
    flex-direction: column;
  }

  .offer-card {
    flex: 1 1 auto;
  }
}

.wizard-offer-name {
  font-weight: 600;
  margin-bottom: 8px;
}

.wizard-offer-list {
  margin: 0;
  padding-left: 18px;
  font-size: 14px;
}

.wizard-form {
  margin-top: 12px;
}

.wizard-field-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px 16px;
}

.wizard-field-grid--residenza {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.wizard-field {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
}

.wizard-field label {
  font-size: 13px;
  margin-bottom: 4px;
}

.wizard-field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.wizard-link-inline {
  border: none;
  background: none;
  color: #2cc9d1;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.wizard-address-grid {
  display: grid;
  grid-template-columns: 1.5fr 0.7fr 0.7fr 1fr 0.8fr;
  gap: 10px 12px;
  margin-top: 8px;
}

.wizard-address-full {
  grid-column: 1 / -1;
}

.wizard-field input {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 10px 12px;
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.wizard-field select {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 10px 12px;
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.wizard-field input::placeholder {
  color: #9ca3af;
}

.wizard-file-name {
  margin-top: 6px;
  font-size: 12px;
  color: #4b5563;
}

.wizard-field-hint {
  margin-top: 6px;
  margin-bottom: 0;
  font-size: 12px;
  color: #6b7280;
}

.wizard-search-dropdown {
  position: relative;
  width: 100%;
}

.wizard-dropdown-input-wrap {
  position: relative;
  width: 100%;
}

.wizard-search-dropdown input {
  width: 100%;
  padding-right: 34px;
}

.wizard-dropdown-caret {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid rgba(16, 185, 129, 0.9);
  pointer-events: none;
}

.wizard-search-dropdown-list {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  z-index: 50;
  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.08);
}

.wizard-search-dropdown-item {
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #111827;
}

.wizard-search-dropdown-item:hover {
  background: rgba(147, 192, 74, 0.12);
}

.wizard-search-dropdown-empty {
  padding: 12px 12px;
  color: #6b7280;
  font-size: 13px;
}

.wizard-thanks {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wizard-thanks-card {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 16px;
  padding: 26px 18px 24px;
  border: 1px solid rgba(147, 192, 74, 0.35);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.wizard-thanks-text {
  margin: 10px 0 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.5;
}

.wizard-thanks-email {
  margin-top: 12px;
  color: #1f2933;
  font-size: 13px;
}

.wizard-thanks-card--error {
  max-width: 560px;
  border: 1px solid rgba(74, 239, 68, 0.22);
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
}

.wizard-title--error {
  margin-top: 10px;
}

.wizard-thanks-text--error {
  font-size: 15px;
  color: #991b1b;
}

.wizard-error-icon {
  width: 52px;
  height: 52px;
  border-radius: 999px;
  margin: 0 auto;
  display: grid;
  place-items: center;
  font-size: 28px;
  font-weight: 700;
  color: #b91c1c;
  background: rgba(239, 68, 68, 0.12);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.wizard-error-help {
  margin: 10px 0 0;
  font-size: 13px;
  color: #6b7280;
}

.wizard-error-action {
  margin-top: 14px;
}

.wizard-checkbox {
  margin-top: 12px;
  font-size: 13px;
}

.wizard-checkbox input {
  margin-right: 6px;
}

.wizard-checkbox--error {
  padding: 6px 8px;
  border-radius: 12px;
  border: 1px solid rgba(185, 28, 28, 0.25);
  background: rgba(185, 28, 28, 0.04);
}

.wizard-radio-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-top: 4px;
  font-size: 13px;
}

.wizard-radio-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.3;
  white-space: normal;
  margin: 0;
}

.wizard-radio-group input {
  margin: 0;
  flex: 0 0 auto;
}

.wizard-radio-group input[type="radio"] {
  width: auto;
  min-width: auto;
  box-sizing: content-box;
}

.wizard-radio-group--inline {
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 24px;
}

.wizard-toggle-group {
  display: inline-flex;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 4px;
  border: 1px solid #d1d5db;
  margin-top: 4px;
  justify-content: center;
}

.wizard-toggle-group--offers {
  margin-top: 12px;
  justify-content: center;
}

.wizard-toggle-center {
  display: flex;
  justify-content: center;
  width: 100%;
}

.wizard-toggle {
  border: none;
  border-radius: 999px;
  padding: 8px 14px;
  background: transparent;
  color: #4b5563;
  font-size: 13px;
  cursor: pointer;
}

.wizard-toggle--active {
  background: linear-gradient(135deg, #93c04a, #2cc9d1);
  color: #ffffff;
}

.wizard-summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-top: 16px;
}

.wizard-summary-box {
  background: #ffffff;
  border-radius: 12px;
  padding: 14px 14px;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.wizard-summary-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
}

.wizard-conditions {
  margin-top: 18px;
}

.wizard-consent-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 18px;
  margin-top: 8px;
  margin-bottom: 10px;
}

.wizard-consent-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
}

.wizard-consent-label {
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 600;
}

.wizard-legal-paragraph {
  margin: 12px 0;
  font-size: 13px;
  color: #4b5563;
  line-height: 1.5;
}

.wizard-inline-card {
  margin-top: 12px;
  border-radius: 12px;
  padding: 14px 14px 16px;
  border: 1px solid rgba(44, 201, 209, 0.35);
  background: linear-gradient(135deg, rgba(44, 201, 209, 0.06), rgba(147, 192, 74, 0.06));
}

.wizard-inline-note {
  margin: 0 0 10px;
  font-size: 13px;
  color: #111827;
}

.wizard-accordion {
  margin-top: 12px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 10px 12px;
  cursor: pointer;
}

.wizard-accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
}

.wizard-accordion-icon {
  margin-right: 4px;
}

.wizard-accordion-title {
  flex: 1;
  font-weight: 600;
}

.wizard-accordion-arrow {
  font-size: 11px;
  color: #6b7280;
}

.wizard-accordion-body {
  margin-top: 8px;
  font-size: 13px;
  color: #4b5563;
}

.wizard-accordion-fade-enter-active,
.wizard-accordion-fade-leave-active {
  transition: all 0.18s ease;
}

.wizard-accordion-fade-enter-from,
.wizard-accordion-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.wizard-conditions {
  margin-top: 20px;
  font-size: 13px;
}

.wizard-footer {
  max-width: 960px;
  margin: 24px auto 0;
  gap: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wizard-primary-button {
  border: none;
  border-radius: 999px;
  padding: 10px 32px;
  background: linear-gradient(135deg, #93c04a, #2cc9d1);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 10px 25px rgba(147, 192, 74, 0.35);
}

.wizard-primary-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}

.wizard-btn-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.wizard-spinner {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #ffffff;
  animation: wizard-spin 0.8s linear infinite;
}

@keyframes wizard-spin {
  to {
    transform: rotate(360deg);
  }
}

.wizard-secondary-button {
  margin-top: 8px;
  align-self: flex-start;
  border-radius: 999px;
  border: none;
  padding: 8px 18px;
  font-size: 13px;
  background: #ffffff;
  color: #365314;
  border: 1px solid #93c04a;
  cursor: pointer;
}

.wizard-secondary-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.wizard-otp-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wizard-otp-actions .wizard-secondary-button {
  margin-top: 0;
  align-self: auto;
}

.wizard-link-button {
  margin-top: 4px;
  padding: 0;
  border: none;
  background: none;
  color: #93c04a;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  align-self: flex-start;
}

.wizard-link-back {
  border: none;
  border-radius: 999px;
  padding: 10px 24px;
  background: linear-gradient(135deg, #93c04a, #2cc9d1);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.wizard-link-back:disabled {
  opacity: 0.4;
  cursor: default;
}

.mt-8 {
  margin-top: 8px;
}

.wizard-secondary-button-danger {
  margin-top: 8px;
  border-radius: 999px;
  border: none;
  padding: 15px 25px;
  font-size: 13px;
  background: linear-gradient(135deg, #f44336cf, #f44336);
  color: #ffffff;
  border: 1px solid #f44336;
  cursor: pointer;
  }

@media (max-width: 640px) {
  .agf-wizard {
    padding: 16px 10px 16px;
  }

  .wizard-logo {
    max-width: 230px;
    margin-top: 8px;
  }

  .wizard-card {
    padding: 16px 14px 18px;
    max-width: 100%;
  }

  .wizard-card--xwide {
    padding-left: 12px;
    padding-right: 12px;
  }

  .wizard-toggle-group--offers {
    width: 100%;
    max-width: 340px;
  }

  .wizard-toggle {
    flex: 1;
    padding: 8px 10px;
    font-size: 12px;
  }

  .wizard-title {
    font-size: 17px;
  }

  .wizard-info-box {
    margin-bottom: 16px;
    padding: 12px 14px;
  }

  .wizard-info-box-title,
  .wizard-info-box-text,
  .wizard-info-box-list {
    font-size: 13px;
  }

  .wizard-header {
    gap: 8px;
    margin-bottom: 2px;
  }

  .wizard-steps {
    gap: 16px;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .wizard-step-circle {
    width: 26px;
    height: 26px;
    font-size: 12px;
  }

  .wizard-step-label {
    font-size: 11px;
  }

  .wizard-step-line {
    width: 25px;
    left: calc(56% + 14px); 
    transform: translateY(-50%);
    display: none;
  }

  .wizard-main {
    margin-top: 40px;
    max-width: 100%;
  }

  .wizard-address-grid {
    grid-template-columns: 1fr;
  }

  .wizard-field-inline--address {
    grid-column: 1 / -1;
  }

  .wizard-field-grid {
    grid-template-columns: 1fr;
  }

  .wizard-radio-group {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .wizard-radio-group--inline {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 16px;
  }

  .wizard-summary-grid {
    grid-template-columns: 1fr;
  }

  .offer-card {
    padding: 16px 14px 18px;
  }

  .offer-card-title {
    font-size: 16px;
    margin-top: 12px;
  }

  .offer-card-price {
    font-size: 22px;
  }

  .offer-card-combined-row {
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
    margin-bottom: 14px;
  }

  .offer-card-side {
    width: 100%;
  }

  .wizard-dialog-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .wizard-dialog-btn {
    width: 100%;
  }

  .wizard-consent-grid {
    grid-template-columns: 1fr;
  }

  .wizard-footer {
    max-width: 100%;
    padding: 0 6px 10px;
    gap: 10px;
    margin-bottom: 20px;
  }

  .wizard-primary-button,
  .wizard-link-back {
    min-height: 44px;
    padding: 10px 14px;
    font-size: 15px;
    line-height: 1.1;
    white-space: nowrap;
  }

  .wizard-primary-button {
    flex: 1.25;
    text-align: center;
  }

  .wizard-link-back {
    flex: 1;
    text-align: center;
  }

  .wizard-otp-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .wizard-otp-actions .wizard-secondary-button {
    width: 100%;
  }

  .wizard-secondary-button-danger {
  margin-top: 8px;
  border-radius: 999px;
  border: none;
  padding: 10px 25px;
  font-size: 13px;
  background: linear-gradient(135deg, #f44336cf, #f44336);
  color: #ffffff;
  border: 1px solid #f44336;
  cursor: pointer;
  }
}
</style>
